export const NIELSEN_LOOKER_PERIOD = 'period_code';
export const NielsenLookerPeriodType = typeof NIELSEN_LOOKER_PERIOD;
export const DATE_LOOKER_PERIODS = [
    'date_key_date',
    'date_key_week',
    'date_key_month',
    'date_filter',
    'comparaison_date_range',
    'compare_to',
    'detention_window',
    /** @deprecated use date_filter. To be deleted when likeForLike view allow date_filter usage */
    'date_key'
];
export const LOOKER_PERIODS = [...DATE_LOOKER_PERIODS, NIELSEN_LOOKER_PERIOD];
export const PERIODS_DEFAULT = ['weekly', 'monthly'];
export const PERIODS = ['daily', 'weekly', 'monthly', 'nielsen'];
export function isPeriod(value) {
    return typeof value === 'string' && PERIODS.includes(value);
}
export const PERIOD_TO_LOOKER_PERIOD = {
    daily: 'date_key_date',
    weekly: 'date_key_week',
    monthly: 'date_key_month',
    nielsen: 'period_code'
};
export const LOOKER_PERIOD_TO_PROJECT_PERIOD = {
    date_key_date: 'daily',
    date_key_week: 'weekly',
    date_key_month: 'monthly'
};
export const DATE_SELECTION_OPTIONS = ['dateRange', 'year_to_date', 'cumulative_to_date', 'last_period'];
export function isDateSelectionOption(value) {
    return typeof value === 'string' && DATE_SELECTION_OPTIONS.includes(value);
}
/* *** TAXONOMY *** */
export const PRODUCT_TAXONOMIES = ['carrefour', 'nielsen'];
export const isProductTaxonomy = (value) => PRODUCT_TAXONOMIES.includes(value);
/* *** PERIMETERS *** */
export const STORE_PERIMETERS = ['allStores', 'likeForLike'];
export const isStorePerimeterType = (value) => STORE_PERIMETERS.includes(value);
/**
 * store_key value injected when the resolved like-for-like perimeter is empty, so Looker
 * matches zero rows instead of dropping the filter. Letters and hyphens only: '_' and '%'
 * are Looker wildcards, a leading '-' negates, ',' separates values.
 */
export const LIKE_FOR_LIKE_EMPTY_PERIMETER_STORE_KEY = 'no-eligible-store';
/** Filters that invalidate the like-for-like perimeter */
export const LIKE_FOR_LIKE_PERIMETER_FILTER_KEYS = [
    'store_key',
    'store_chain_type_key',
    'store_chain_type_desc',
    'store_region_key',
    'store_region_desc',
    'store_int_flag',
    'activity_type'
];
/* *** FILTERS *** */
export const SIMPLE_FILTERS = [
    'integratedFranchised',
    'activityType',
    'chainType',
    'assortmentTypology',
    'productTypology',
    'competitor',
    'userSupplierRootKey'
];
export const KPI_SCOPE_FILTERS = [
    'activity_type',
    'main_holding_key', // Fournisseur
    'bem_merchandise_key',
    'supplier_key', // Sub supplier
    'perimeter_main_holding_key',
    'perimeter_supplier_key',
    'supplier_root_key', // Local supplier
    'brand_key',
    'brand_key_anonymized',
    'brand_desc',
    'brand_type_key',
    'store_chain_type_desc',
    'store_chain_type_key',
    'sector_key',
    'department_key',
    'store_key',
    'store_region_desc',
    'store_region_key',
    'store_int_flag',
    'grp_class_key',
    'class_key',
    'sub_class_key',
    'item_key',
    'barcode',
    'barcode_anonymized',
    'item_key_anonymized',
    'isWithTax',
    'assort_key',
    'ch_typo_key',
    'competitor_supplier_root_key',
    'view_type',
    'shopper_seg_type',
    'shopper_seg_granularity',
    'shopper_seg_sections',
    'consostyle_micro_key',
    'not_in_consostyle_micro_key',
    'lifestage_micro_key',
    'destination_analysis_type',
    'trad_consostyle_micro_distribution',
    'trad_consostyle_macro_distribution',
    'not_in_trad_consostyle_micro_distribution',
    'not_in_trad_consostyle_macro_distribution',
    'trad_lifestage_micro_distribution',
    'trad_lifestage_macro_distribution',
    'not_in_trad_lifestage_micro_distribution',
    'not_in_trad_lifestage_macro_distribution',
    'lifestage_micro_key',
    'not_in_lifestage_micro_key',
    'business_brand',
    'business_brand_reduced',
    'segment_dim_type'
];
export const PRODUCT_REFERENTIAL_FILTERS = [
    'brandType',
    'sector',
    'department',
    'grpClass',
    'class',
    'subClass',
    'item',
    'mainItem',
    'barcode',
    'competitorBaseItem',
    'competitorBaseBarcode',
    'competitorComparisonItem',
    'competitorComparisonBarcode'
];
export function isProductReferentialFilterType(value) {
    return PRODUCT_REFERENTIAL_FILTERS.includes(value);
}
export const STORE_REFERENTIAL_FILTERS = [
    'bemMainHolding', // this is more a product referential filter
    'bemMerchandise',
    'subSupplier', // this is more a product referential filter
    'localSupplier', // this is more a product referential filter
    'brand', // this is more a product referential filter — numeric brand_key
    'brandDesc', // brand filter by label (brand_desc) — used by projects
    'activityType',
    'chainType',
    'store',
    'region',
    'integratedFranchised',
    'competitor',
    'businessBrand',
    'businessBrandReduced'
];
export function isStoreReferentialFilterType(value) {
    return STORE_REFERENTIAL_FILTERS.includes(value);
}
export const POSSESSION_FILTERS = ['assortmentTypology', 'productTypology'];
export const COMPETITOR_FILTERS = ['competitor', 'userSupplierRootKey', 'competitorBrand'];
export const CUSTOMER_SEGMENTATION_FILTERS = [
    'customerSegmentationType',
    'customerSegmentationViewType',
    'customerSegmentationGranularity',
    'customerSegmentationSections',
    'consostyleMicro',
    'notInConsostyleMicro',
    'notInTradConsostyleMacro',
    'notInTradConsostyleMicro',
    'tradConsostyleMicroDistribution',
    'tradConsostyleMacroDistribution',
    'tradLifestageMicroDistribution',
    'tradLifestageMacroDistribution',
    'notInTradLifestageMicro',
    'notInTradLifestageMacro',
    'lifestageMicro',
    'notInLifestageMicro',
    'segmentDimType'
];
export const ALL_FILTER_TYPES = [
    ...PRODUCT_REFERENTIAL_FILTERS,
    ...STORE_REFERENTIAL_FILTERS,
    ...POSSESSION_FILTERS,
    ...COMPETITOR_FILTERS,
    ...CUSTOMER_SEGMENTATION_FILTERS
];
export function isFilterTypeGuard(filter) {
    return ALL_FILTER_TYPES.includes(filter);
}
export const FILTER_NAME_TO_KPI_FILTER = {
    activityType: 'activity_type',
    bemMainHolding: 'main_holding_key',
    bemMerchandise: 'bem_merchandise_key',
    subSupplier: 'supplier_key',
    localSupplier: 'supplier_root_key',
    brand: 'brand_key',
    brandDesc: 'brand_desc',
    brandType: 'brand_type_key',
    chainType: 'store_chain_type_key',
    region: 'store_region_key',
    class: 'class_key',
    department: 'department_key',
    grpClass: 'grp_class_key',
    item: 'item_key',
    mainItem: 'barcode',
    sector: 'sector_key',
    integratedFranchised: 'store_int_flag',
    store: 'store_key',
    subClass: 'sub_class_key',
    barcode: 'barcode',
    assortmentTypology: 'assort_key',
    productTypology: 'ch_typo_key',
    competitor: 'competitor_supplier_root_key',
    userSupplierRootKey: 'supplier_root_key', // Factice filter to display user supplier root keys in competitor filter popup
    competitorBaseBarcode: 'barcode_anonymized',
    competitorBaseItem: 'item_key_anonymized',
    competitorComparisonBarcode: 'barcode_anonymized',
    competitorComparisonItem: 'item_key_anonymized',
    competitorBrand: 'brand_key_anonymized',
    customerSegmentationType: 'shopper_seg_type',
    customerSegmentationViewType: 'view_type',
    customerSegmentationGranularity: 'shopper_seg_granularity',
    customerSegmentationSections: 'shopper_seg_sections',
    consostyleMicro: 'consostyle_micro_key',
    notInConsostyleMicro: 'not_in_consostyle_micro_key',
    tradConsostyleMicroDistribution: 'trad_consostyle_micro_distribution',
    tradConsostyleMacroDistribution: 'trad_consostyle_macro_distribution',
    notInTradConsostyleMicro: 'not_in_trad_consostyle_micro_distribution',
    notInTradConsostyleMacro: 'not_in_trad_consostyle_macro_distribution',
    tradLifestageMicroDistribution: 'trad_lifestage_micro_distribution',
    tradLifestageMacroDistribution: 'trad_lifestage_macro_distribution',
    notInTradLifestageMicro: 'not_in_trad_lifestage_micro_distribution',
    notInTradLifestageMacro: 'not_in_trad_lifestage_macro_distribution',
    lifestageMicro: 'lifestage_micro_key',
    notInLifestageMicro: 'not_in_lifestage_micro_key',
    businessBrand: 'business_brand',
    businessBrandReduced: 'business_brand_reduced',
    segmentDimType: 'segment_dim_type'
};
export const KPI_FILTER_TO_FILTER_NAME = {
    activity_type: 'activityType',
    main_holding_key: 'bemMainHolding',
    bem_merchandise_key: 'bemMerchandise',
    supplier_key: 'subSupplier',
    supplier_root_key: 'localSupplier',
    brand_key: 'brand',
    brand_key_anonymized: 'competitorBrand',
    brand_desc: 'brandDesc',
    brand_type_key: 'brandType',
    store_chain_type_key: 'chainType',
    store_region_key: 'region',
    class_key: 'class',
    department_key: 'department',
    grp_class_key: 'grpClass',
    item_key_anonymized: 'competitorBaseItem',
    item_key: 'item',
    barcode: 'barcode',
    barcode_anonymized: 'competitorBaseBarcode',
    sector_key: 'sector',
    store_int_flag: 'integratedFranchised',
    store_key: 'store',
    sub_class_key: 'subClass',
    assort_key: 'assortmentTypology',
    ch_typo_key: 'productTypology',
    competitor_supplier_root_key: 'competitor',
    shopper_seg_type: 'customerSegmentationType',
    view_type: 'customerSegmentationViewType',
    shopper_seg_granularity: 'customerSegmentationGranularity',
    consostyle_micro_key: 'consostyleMicro',
    not_in_consostyle_micro_key: 'notInConsostyleMicro',
    not_in_trad_consostyle_micro_distribution: 'notInTradConsostyleMicro',
    not_in_trad_consostyle_macro_distribution: 'notInTradConsostyleMacro',
    trad_consostyle_micro_distribution: 'tradConsostyleMicroDistribution',
    trad_consostyle_macro_distribution: 'tradConsostyleMacroDistribution',
    not_in_trad_lifestage_micro_distribution: 'notInTradLifestageMicro',
    not_in_trad_lifestage_macro_distribution: 'notInTradLifestageMacro',
    trad_lifestage_micro_distribution: 'tradLifestageMicroDistribution',
    trad_lifestage_macro_distribution: 'tradLifestageMacroDistribution',
    lifestage_micro_key: 'lifestageMicro',
    not_in_lifestage_micro_key: 'notInLifestageMicro',
    business_brand: 'businessBrand',
    business_brand_reduced: 'businessBrandReduced'
};
//# sourceMappingURL=kpis-perimeter.model.js.map